const extractBase64 = (dataUrl: string | undefined): string | null => {
	if (!dataUrl) return null;
	const base64 = dataUrl.split(',')[1];
	return base64 ?? null;
};

export {extractBase64};
